import React, {PropsWithChildren} from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {IStickyHandler} from '../sticky-handler/sticky-handler.interface';
import {LobbyHeaderBox} from "./boxes/lobby-header.box";
import {LobbyHeaderTitleBox} from "./boxes/title/lobby-header-title.box";
import {LobbyHeaderLineBox} from "./boxes/line/lobby-header-line.box";
import classNames from 'classnames';
import {STICKY} from "../../themes/css-global-classes";
import {CyClass} from "../../../common/cy-classes";
import {LobbyHeaderButtonsContainerBox} from "./boxes/buttons/lobby-header-buttons-container.box";
import {LobbyHeaderButtonsBox} from "./boxes/buttons/lobby-header-button.box";
import {ThemeProvider} from "styled-components";
import { LobbyHeaderTitleContainerBox } from './boxes/title/lobby-header-title.container.box';
import {Nullable} from "../../../common/types/nullable-types";
import {
  IPcFilterIndicatorRenderingOptions,
  PcFilterIndicatorRenderingLocation
} from "../../services/games-filter/games-filter.service.interface";

export interface LobbyHeaderComponentProps extends PropsWithChildren{
  stickyHandler: IStickyHandler;
  title: string;
  showSearchIcon: boolean;
  arenaFiltersRenderingOptions?: Nullable<IPcFilterIndicatorRenderingOptions>;
}

export const LobbyHeaderComponent = observer(
  class LobbyHeaderComponent extends OrbitComponent<LobbyHeaderComponentProps> {

    private handleSearchClick = () => {
      this.services.gameSearch.openSearchResult();
    }

    private _renderFiltersIndicatorUnderTheTitle() {
      const renderingOptions = this.services.gamesFilter.renderPCFiltersIndicator();

      if(renderingOptions?.location !== PcFilterIndicatorRenderingLocation.BelowArenaTitle) {
        return null;
      }

      return renderingOptions.reactElement;
    }

    private _renderFiltersIndicatorNextToTheTitle() {
      const renderingOptions = this.services.gamesFilter.renderPCFiltersIndicator();

      if(renderingOptions?.location !== PcFilterIndicatorRenderingLocation.NextToArenaTitle) {
        return null;
      }

      return renderingOptions.reactElement;
    }

    render() {

      const isMobile = this.services.device.isMobile;
      const lobbyHeaderClasses = classNames('cy-lobby-header', {
        [STICKY]: this.props.stickyHandler.isSticky
      });

      const SearchIcon = this.services.theme.currentTheme.icons.searchIcon;
      //console.log('HeaderHeight: ' + this.services.header.headerHeight);
      return (
          <ThemeProvider theme={this.services.theme.currentTheme}>
            <LobbyHeaderBox className={lobbyHeaderClasses} stickOffset={this.services.header.headerHeight}>
              {this.props.title &&
                <LobbyHeaderTitleContainerBox>
                  <LobbyHeaderTitleBox className={CyClass("cy-lobby-header-title")}>
                    <span style={{flex: "0 0 auto"}}>
                      {this.services.translation.translate(this.props.title)}
                    </span>
                    {this._renderFiltersIndicatorNextToTheTitle()}
                  </LobbyHeaderTitleBox>
                  { isMobile &&
                    <LobbyHeaderButtonsContainerBox>
                    {
                      this.props.showSearchIcon &&
                      <LobbyHeaderButtonsBox>
                        <div onClick={this.handleSearchClick}>
                          <SearchIcon/>
                        </div>
                      </LobbyHeaderButtonsBox>
                    }
                      {this.services.gamesFilter.renderMobileFiltersIndicator()}
                  </LobbyHeaderButtonsContainerBox>
                 }
                </LobbyHeaderTitleContainerBox>
              }
              {this._renderFiltersIndicatorUnderTheTitle()}
              <LobbyHeaderLineBox/>
            </LobbyHeaderBox>
          </ThemeProvider>
      );
    }
  }
);
